import DocumentPasses from "./views/DocumentPasses"
import HistoricPasses from "./views/HistoricPasses"
import Index from "./views/Index"
import EditNavegantes from "./views/NavegantesEdit"
import RegisterPerson from "./views/RegisterPerson.vue"
import ReportBeneficiarios from "./views/ReportBeneficiarios"
import ReportPasses from "./views/ReportPasses.vue"
import ShowNavegantes from "./views/ShowNavegantes"
import StepThree from "./views/StepThree"
import StepTwo from "./views/StepTwo"

export default [
  {
    path: "/spl-navegantes/relatorios/beneficiarios",
    name: "spl-navegantes.report",
    component: ReportBeneficiarios,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },

  {
    path: "/spl-navegantes/relatorios/passes",
    name: "spl-navegantes.relatorios.passes",
    component: ReportPasses,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },

  {
    path: "/spl-navegantes",
    name: "spl-navegantes.index",
    component: Index,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },
  {
    path: "/spl-navegantes/cadastro",
    name: "spl-navegantes.show",
    component: ShowNavegantes,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },
  {
    path: "/spl-navegantes/:id/editar",
    name: "spl-navegantes.edit",
    component: EditNavegantes,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },
  {
    path: "/spl-navegantes/:id/passes",
    name: "spl-navegantes.documents",
    component: DocumentPasses,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },
  {
    path: "/spl-navegantes/:id/historico",
    name: "spl-navegantes.historic-passes",
    component: HistoricPasses,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },
  {
    path: "/spl-navegantes/cadastro/passo01",
    name: "spl-navegantes.step01",
    component: RegisterPerson,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },

  {
    path: "/spl-navegantes/cadastro/passo02",
    name: "spl-navegantes.step02",
    component: StepTwo,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },

  {
    path: "/spl-navegantes/cadastro/passo03",
    name: "spl-navegantes.step03",
    component: StepThree,
    meta: {
      forAuth: true,
      module: "spl-navegantes",
    },
  },
]
